import React, { ReactNode } from "react";
import { useDroppable } from "@dnd-kit/core";
import { BoxProps, HStack } from "@chakra-ui/react";

interface DropableProps {
  children: ReactNode;
  id: string;
}

export function Dropable(props: DropableProps & BoxProps) {
  const { setNodeRef } = useDroppable({
    id: props.id,
  });

  return (
    <HStack ref={setNodeRef} {...props}>
      {props.children}
    </HStack>
  );
}
